import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { Services } from './components/Services';
import { Academy } from './components/Academy';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { OpeningCurtain } from './components/OpeningCurtain';
import { SeoHead } from './components/SeoHead';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { BookingProvider } from './components/BookingContext';
import { LanguageProvider } from './components/i18n/LanguageContext';
export function App() {
  const [isOpening, setIsOpening] = useState(true);
  const completeOpening = useCallback(() => setIsOpening(false), []);
  return <LanguageProvider data-id="element-0" data-mp="23u9vyt7xrnzx">
      <BookingProvider data-id="element-1" data-mp="23v2s7099qv3t">
      <div className="w-full min-h-screen bg-warm-white text-dark font-sans antialiased" data-id="element-2" data-mp="23ti6m04xmmi3">
        <SeoHead data-id="element-3" data-mp="3ihuyk4ft23e4" />
        <Navbar data-id="element-4" data-mp="3mlj6wpc9h30f" />
        <main data-id="element-5" data-mp="3ml1234bj9ggw">
          <Hero data-id="element-6" data-mp="3mkhn9wh6j873" />
          <Intro data-id="element-7" data-mp="3mjzrt22ccy08" />
          <Services data-id="element-8" data-mp="3mjga9mglsbmq" />
          <Academy data-id="element-9" data-mp="3rc9ca2kot5v4" />
          <Reviews data-id="element-10" data-mp="3rbrcivytg9ig" />
          <Contact data-id="element-11" data-mp="3rdki07xp0nov" />
        </main>
        <Footer data-id="element-12" data-mp="3reccfffk0fdk" />
        <FloatingWhatsApp data-id="element-13" data-mp="5yi8qe3h5da" />

        <AnimatePresence data-id="element-14" data-mp="6817u0q2c9h">
          {isOpening && <OpeningCurtain onComplete={completeOpening} data-id="element-15" data-mp="56lhc8rh1lf" />}
        </AnimatePresence>
      </div>
      </BookingProvider>
    </LanguageProvider>;
}